import Chip from '@navi/web-ui/lib/primitives/Chip/index';
import Button from '@navi/web-ui/lib/primitives/Button/index';
import Typography from '@navi/web-ui/lib/primitives/Typography/index';
import cx from 'classnames';
import { useCallback, useMemo, useReducer } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import { shareEnachLink } from '../../actions/casesDetailsActions';
import styles from './index.module.scss';
import { EnachSetupAction, IsetupEnach } from '../../interfaces/EmiSchedule.type';
import { enachMode, EnachSetupKinds } from '../../constants/EmiSchedule.constant';
import { ITelePhoneData } from '../../interfaces/CaseDetail.type';
import Modal from '@cp/src/components/Modal/Modal';

function enachSetupReducer(state: IsetupEnach, action: EnachSetupAction) {
  const { type } = action;
  switch (type) {
    case EnachSetupKinds.INITIAL_STATE:
      return {
        ...state,
        mode: enachMode.sms,
        number: '',
        open: true
      };
    case EnachSetupKinds.CLOSE:
      return {
        ...state,
        open: false
      };
    // case EnachSetupKinds.UPDATE_THROUGH_WHATSAPP:
    //   return {
    //     ...state,
    //     mode: enachMode.whatsapp
    //   };
    case EnachSetupKinds.UPDATE_THROUGH_SMS:
      return {
        ...state,
        mode: enachMode.sms
      };
    case EnachSetupKinds.BEFORE_API_CALL:
      return {
        ...state,
        loading: true
      };
    case EnachSetupKinds.API_CALL_SUCCESS:
      return {
        ...state,
        loading: false,
        sentLink: true,
        open: false
      };
    default:
      return state;
  }
}

const PresentEnachCard = () => {
  const {
    loanId = '',
    customerId = '',
    caseBusinessVertical = '',
    caseReferenceId = ''
  } = useParams();
  const dispatch = useDispatch();
  const telephones = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]?.telephones
  );
  const [setupEnach, dispatchEnach] = useReducer(enachSetupReducer, {
    mode: enachMode.sms,
    number: '',
    open: false,
    loading: false,
    sentLink: false
  });

  const sendUsingSMS = useCallback(() => {
    dispatchEnach({
      type: EnachSetupKinds.UPDATE_THROUGH_SMS
    });
  }, []);

  const onSuccess = useCallback(() => {
    dispatchEnach({ type: EnachSetupKinds.API_CALL_SUCCESS });
  }, []);
  const shareLink = () => {
    dispatchEnach({ type: EnachSetupKinds.BEFORE_API_CALL });
    dispatch(shareEnachLink(loanId, customerId, onSuccess, caseReferenceId, caseBusinessVertical));
  };

  const openDialog = useCallback(
    () =>
      dispatchEnach({
        type: EnachSetupKinds.INITIAL_STATE
      }),
    []
  );

  const closeModal = useCallback(
    () =>
      dispatchEnach({
        type: EnachSetupKinds.CLOSE
      }),
    []
  );

  const primaryContact: ITelePhoneData | undefined = useMemo(
    () => telephones?.data?.find(telephone => telephone.source === 'PRIMARY'),
    [telephones?.data]
  );

  const isCasePaused = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.pause?.data?.isPaused
  );

  return (
    <>
      <div className={cx([styles.paymentLinkContainer])}>
        <Typography className={styles.headerName} variant={'h3'}>
          Auto pay not setup
        </Typography>
        <Button
          onClick={openDialog}
          variant={'text'}
          disabled={setupEnach.sentLink || isCasePaused}
        >
          Share setup link
        </Button>
      </div>
      <Modal visible={setupEnach.open} onClose={closeModal} header="Enach setup link">
        <div className={styles.persentEnach}>
          <Typography className={cx([styles.greyScale2, styles.modeOfContact])} variant={'p4'}>
            Mode of contact
          </Typography>
          <Chip
            // onChipClick={sendUsingSMS}
            // wrapperClasses={cx([{ [styles.chipActiveColor]: setupEnach.mode === enachMode.sms }])}
            wrapperClasses={styles.chipActiveColor}
            labelClasses={styles.text}
            label="SMS"
          />
          <Chip
            // onChipClick={sendUsingWhatsApp}
            wrapperClasses={cx([
              // { [styles.chipActiveColor]: setupEnach.mode === enachMode.whatsapp },
              styles.ml12,
              styles.chipActiveColor
            ])}
            labelClasses={cx([styles.text])}
            label="Whatsapp"
          />
          <Typography className={cx([styles.greyScale2, styles.modeOfContact])} variant={'p4'}>
            Selected Number
          </Typography>
          <Typography className={cx([styles.greyScale1])} variant={'p4'}>
            {primaryContact?.number}
          </Typography>
          {/* <select className={styles.phoneNumberDropDown}>
            {telephones?.data?.map(values => (
              <option key={values.number} value={values.number}>
                {values.number}
              </option>
            ))}
          </select> */}
          <Button disabled={setupEnach.sentLink} onClick={shareLink} className={styles.sendLink}>
            Send Link
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default PresentEnachCard;
